import dayjs from "dayjs";

/**
 * Validator for a rental's end date: it may not precede the start date.
 *
 * The API accepts such a range on create and update — only *opening* a rental
 * checks the dates (RentalService::canStartRental) — so the form is where the
 * mistake has to be caught, before it is persisted.
 *
 * Deliberately a field-level validator rather than a form-level `validate` prop:
 * react-admin ignores every per-input validator as soon as a form-level function
 * is given, which would silently drop the `required()` rules on the name and the
 * two dates. As a field validator it composes with them instead.
 *
 * Values arrive as dayjs objects when the form is seeded from a record (see
 * rentalConverter) and as "YYYY-MM-DD" strings once a DateInput has been edited,
 * so both are normalised through dayjs; the comparison is by day, since these are
 * date-only fields. The returned message is a translation key (react-admin
 * translates validation messages) and reuses the wording the backend already uses
 * for the same rule.
 */
export const endDateNotBeforeStartDate = (value, allValues) => {
    if (!value || !allValues?.startDate) {
        return undefined;
    }

    return dayjs(value).isBefore(dayjs(allValues.startDate), "day")
        ? "error.rental.rental_dates"
        : undefined;
};
